import { render, staticRenderFns } from "./Genially.vue?vue&type=template&id=5daec224&"
import script from "./Genially.vue?vue&type=script&lang=js&"
export * from "./Genially.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports